import { styled } from "@mui/material/styles";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Box, Grid, MenuItem, Tooltip, Typography } from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { MdVerified } from "react-icons/md";
import { IoIosInformationCircle } from "react-icons/io";

import { TableCell, TableRow } from "@mui/material";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useAxios } from "../../hooks";
import pages from "./../../constants/pages";
import convertDate from "./../../utils/convertDate";
import ImagePopup from "./ImagePopup";
import LoadingButton from "./../../components/LoadingButton";
import ParkingDetialsPopup from "./ParkingDetails";
import { TextField } from "../../components";
import { useSelector } from "react-redux";
import { IoIosArrowForward } from "react-icons/io";
import UserDetailPopUp from "./UserDetailPopUp";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import Color from "../../theme/color";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  min-height: 75vh;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 17px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  min-height: 50vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

const TableCells = styled(TableCell)`
  // display: flex;
`;

const EventBox = styled(Grid)`
  background-image: url(${(props) => props.backgroundImage});
  background-size: 100% 100%;
  position: relative;
  background-repeat: no-repeat;
  margin: 0px !important;
  width: 100%;
  height: 25vh !important;
  border-top-left-radius: 12.5px;
  border-top-right-radius: 12.5px;
`;

const GradientOverlay = styled("div")({
  width: "100%",
  height: "100%",
  borderRadius: "12.5px",
  backgroundImage:
    "linear-gradient(rgba(255, 255, 255, 0) 50%, rgb(255 255 255 / 62%) 100%)",
});
// visitor_id=8aecde314bdb44358024c66c424636a4&booking_id=AMIT233&event_id=c0c26ad15e92409c907fc51320beade2&user_type_id=1
export default function EventSummary() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { state, search } = useLocation();
  // const { id } = useParams();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(search);

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");
  const digiLockerID = queryParams.get("id");

  const oldDom = useRef(null);

  const [eventDetails, setEventDetails] = useState({});
  const [userData, setUserData] = useState(state);
  const [premises, setPremisesData] = useState([]);

  const [badges, setBadges] = useState([]);

  const [open, setOpen] = useState(false);
  const [openParkingDetial, setOpenParkingDetial] = useState(false);

  const [userDetial, setUserDetial] = useState([]);
  const [userDetialPopUp, setUserDetialPopUp] = useState(false);

  const userPayloadString = localStorage.getItem(
    `userPayload_${visitorData.ID}`
  );
  const userPayload = JSON.parse(userPayloadString);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorID) && !item.includes("userPayload");
  });

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    axios({
      url: `/admin/profile/get-premises-banner?premises_id=${entityID}`,
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setPremisesData(response.data);
      }
    });
  }, []);

  useEffect(() => {
    axios({
      url: `event/booking/get-visitor-badges?visitor_id=${visitorID}&event_id=${entityID}`,
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setBadges(response.data);
      }
    });

    axios({
      url: `admin/events/event-details?event_id=${entityID}`,
      method: "GET",
      customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
    }).then((response) => {
      if (response.status) {
        response?.data?.button_color &&
          sessionStorage.setItem("buttonColor", response.data.button_color);
        response?.data?.background_color &&
          sessionStorage.setItem(
            "buttonBackground",
            response.data.background_color
          );
        setEventDetails(response.data);
      }
    });

    if (!Boolean(state?.match_percentage)) {
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        if (response.status) {
          if (response.data[0].journey_status.user_status == "Verify") {
            navigate(response.data[0].journey_status.page_link);
          }
          setUserData({ userData: response.data });
          // axios({
          //   url: `event/verify/booking-status`,
          //   method: "POST",
          //   disableRedirect: true,
          //   data: {
          //     name: "",
          //     face_data: "",
          //     booking_id: response?.data[0]?.booking_id,
          //   },
          // });
        }
      });
    }
  }, [axios, entityID]);

  const renderInfoItem = (label, value) => (
    <TableRow>
      <TableCells sx={{ width: "40%" }}>
        <Typography
          variant="body1"
          style={{ color: "rgb(150 150 150)" }}
          fontWeight={900}
        >
          {label}
        </Typography>
      </TableCells>
      <TableCells sx={{ width: "60%" }}>
        <Tooltip title={value}>
          <Typography
            variant="h6"
            fontWeight={900}
            sx={{
              color: value === "pending" ? "red" : "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "1rem",
              "@media (max-width: 425px)": {
                fontSize: "0.875rem",
              },
            }}
          >
            {value?.toUpperCase()}
          </Typography>
        </Tooltip>
      </TableCells>
    </TableRow>
  );

  useEffect(() => {
    window.addEventListener("afterprint", (event) => {
      document.body.innerHTML = oldDom.current;
      oldDom.current = null;
    });
  }, []);

  return (
    <OuterBox>
      {eventDetails?.is_parking && (
        <Grid
          item
          container
          sx={{ marginTop: "12.5px", display: "flex", justifyContent: "end" }}
        ></Grid>
      )}

      <Grid item xs={12} mt={4}>
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            fontWeight: "bolder",
            "-webkit-text-stroke-width": ".5px",
            marginBottom: "15px",
          }}
        >
          Booking Summary
        </Typography>
      </Grid>

      <EventBox
        backgroundImage={
          premises.premises_banner ||
          eventDetails?.banner_image ||
          "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/3e9c86447ad14afb8b260fe48efe0eb0/1724237319019_image-cache.jpeg"
        }
        style={{
          position: "relative",
          backgroundRepeat: "no-repeat",
          margin: " 0px !important",
          width: "92.5%",
          height: "25vh !important",
          borderRadius: "12.5px",
        }}
      >
        <GradientOverlay />
        <Grid
          item
          container
          position="absolute"
          bottom={0}
          sx={{
            justifyContent: "space-between",
            padding: "20px 5%",
          }}
        >
          <Grid
            item
            xs={8}
            sx={{
              backgroundColor: "white",
              padding: "5px",
              borderRadius: "7.5px",
              boxShadow: "2px 2px 5px 0px #0000008a",
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{
                WebkitTextStrokeWidth: ".5px",
                fontSize: { xs: ".85rem", md: "1rem" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {eventDetails.event_name}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: ".85rem", md: "1rem" },
              }}
              fontWeight="bold"
              color="#747474"
            >
              {convertDate(eventDetails.event_start_date)}{" "}
              <PlaceOutlinedIcon
                sx={{
                  verticalAlign: "bottom",
                  color: "#3869db",
                  width: { xs: "1rem", md: "2rem" },
                }}
              />
            </Typography>
          </Grid>
        </Grid>
      </EventBox>
      {console.log(userData, "userData")}
      {Array(
        userData?.userData[0]?.badges?.length > 0
          ? userData?.userData[0].total_number_bookings
          : 1
      )
        .fill(true)
        .map((item, index) => {
          return (
            <OuterPaper
              sx={{
                padding: {
                  xs: index != 0 ? "10px 0px 0px 0px" : "20px 0px 0px 0px",
                  sm: index != 0 ? "10px 80px 0px 80px" : "20px 80px 0px 80px",
                },
                alignContent: "start !important",
                minHeight: "0 !important",
              }}
            >
              {userData?.userData[index]?.visitor_info?.first_name && (
                <Grid
                  item
                  container
                  sx={{
                    border: "0.6px solid #0000001A",
                    borderRadius: "8px",
                    marginTop: "7px",
                  }}
                >
                  <Grid item container p={"7.5px 0px"}>
                    <Grid item container p={"5px 10px 10px 15px"}>
                      <Grid
                        item
                        xs={3}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          ml: 2,
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontWeight={"bolder"}
                          fontSize={"14px"}
                        >
                          {userData?.userData[index]?.visitor_info?.first_name}
                        </Typography>

                        <Typography
                          variant="body1"
                          fontWeight={400}
                          fontSize={"12px"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {
                            userData?.userData[index]?.visitor_info
                              ?.phone_number
                          }
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={8}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          borderRadius: "4px",
                          alignItems: "center",
                        }}
                      >
                        <Grid
                          item
                          container
                          mt={2}
                          sx={{
                            alignSelf: "center",
                            justifyContent: "end",
                          }}
                        >
                          <Grid item xs={4}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => {
                                setUserDetial(userData?.userData[index]);
                                setUserDetialPopUp(true);
                              }}
                              style={{
                                fontSize: "12px",
                                padding: "5px",
                                marginRight: "4px",
                              }}
                            >
                              Info
                            </LoadingButton>
                          </Grid>
                          {!Boolean(
                            userData?.userData[index]?.user_type == "primary" &&
                              (index > 0
                                ? !userData?.userData[index]?.journey_status
                                    ?.qr_link
                                : true)
                          ) && (
                            <Fragment>
                              {Boolean(
                                userData?.userData[index]?.journey_status
                                  ?.page_link
                              ) && (
                                <Grid item>
                                  <LoadingButton
                                    className="userDetailButton"
                                    variant="outlined"
                                    onClick={() =>
                                      navigate(
                                        userData?.userData[index]
                                          ?.journey_status?.page_link
                                      )
                                    }
                                    disabled={
                                      !userData?.userData[index]?.primary_user
                                    }
                                    style={{
                                      fontSize: "12px",
                                      padding: "5px",
                                      border: `1px solid ${Color.digipass}`,
                                      color: Color.digipass,
                                    }}
                                    backgroundColor={"white"}
                                  >
                                    {userData?.userData[
                                      index
                                    ]?.journey_status?.user_status
                                      .toUpperCase()
                                      .replace("_", " ")}
                                  </LoadingButton>
                                </Grid>
                              )}
                            </Fragment>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </OuterPaper>
          );
        })}

      {Boolean(state?.match_percentage && userPayload?.doc_face_image) && (
        <Grid
          container
          pt={"10px"}
          sx={{
            width: "100%",
            padding: { xs: "30px 0px 0px 0px", sm: "30px 80px 0px 80px" },
          }}
        >
          <Grid
            item
            container
            sx={{
              boxShadow: "rgb(0 0 0 / 53%) 0px 3px 15px",
              padding: "8.5px",
              borderRadius: "12.5px",
              height: "100px",
            }}
          >
            <Grid item xs={4} sx={{ position: "relative" }}>
              <img
                width="100%"
                height="80px"
                style={{ objectFit: "initial", borderRadius: "8px" }}
                src={"data:image/png;base64," + userPayload?.doc_face_image}
                alt="Preview"
              />

              <MdVerified
                style={{
                  color: "green",
                  bottom: "10px",
                  right: "5px",
                  fontSize: "25px",
                  position: "absolute",
                  borderRadius: "15px",
                  background: "white",
                }}
              />
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  padding: "10px",
                  fontWeight: "bold",
                  "-webkit-text-stroke": ".5px",
                }}
              >
                Verification Done{"  "}
                <IoIosInformationCircle
                  style={{
                    color: "blue",
                    fontSize: "20px",
                    verticalAlign: "middle",
                  }}
                  onClick={() => setOpen(true)}
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {state && userPayload?.doc_face_image && (
        <ImagePopup
          open={open}
          setOpen={setOpen}
          state={state}
          userPayload={userPayload}
        />
      )}

      {/* <ParkingDetialsPopup
        eventID={eventID}
        bookingId={userData?.userData[0]?.booking_id}
        openParkingDetial={openParkingDetial}
        setOpenParkingDetial={setOpenParkingDetial}
      /> */}

      <UserDetailPopUp
        userDetial={userDetial}
        setUserDetial={setUserDetial}
        userDetialPopUp={userDetialPopUp}
        renderInfoItem={renderInfoItem}
        badges={badges}
        setUserDetialPopUp={setUserDetialPopUp}
      />
    </OuterBox>
  );
}
